import { Component, Host, h, Prop, Element } from '@stencil/core';
import Swiper from 'swiper';
import store from '../../../../global/store';

@Component({
  tag: 'ui-bank-search-mobile-slider',
  styleUrl: 'ui-bank-search-mobile-slider.scss',
  shadow: false,
  assetsDirs: ['assets'],
})
export class UiBankSearchMobileSlider {
  @Element() el: HTMLElement;

  @Prop() uniqueId = '123';

  private container?: HTMLDivElement;

  private wrapper?: HTMLDivElement;

  private swiper?: Swiper;

  onVisibleResultsChange() {
    this.swiper?.slideTo(this.swiper.activeIndex, 0, false);
  }

  onSelectedPlaceLocationChange() {
    this.swiper?.slideTo(0, 0, false);
  }

  updateSwiper() {
    this.swiper?.update();
  }

  componentWillLoad() {
    store.onChange('resultsTotal', () => {
      this.updateSwiper();
    });
    store.onChange('resultsVisibleCount', () => {
      this.onVisibleResultsChange();
      this.updateSwiper();
    });
    store.onChange('selectedPlaceLocation', () => {
      this.onSelectedPlaceLocationChange();
    });
  }

  componentDidUpdate() {
    if (
      !this.swiper &&
      store.state.resultsTotal &&
      store.state.resultsVisibleCount
    ) {
      this.initSwiper();
    }
  }

  componentDidLoad() {
    this.componentDidUpdate();
  }

  private initSwiper() {
    // eslint-disable-next-line no-new
    this.swiper = new Swiper(this.container, {
      effect: 'slide',
      centeredSlides: true,
      autoHeight: true,
      slidesPerView: 1.2,
      slidesPerGroup: 1,
      spaceBetween: 10,
      watchOverflow: true,
      observer: true,
    });

    ([].slice.call(this.wrapper.children) as HTMLElement[]).map((slide, idx) =>
      slide.addEventListener('click', () => {
        if (this.swiper.activeIndex + 1 === idx) {
          this.swiper.slideNext();
        }
        if (this.swiper.activeIndex - 1 === idx) {
          this.swiper.slidePrev();
        }
      })
    );

    this.swiper.on('reachEnd', ({ activeIndex }) => {
      if (activeIndex !== 0 && activeIndex !== 29) {
        store.state.loadMore();
      }
    });
  }

  render() {
    return (
      <Host
        class={{
          condensed: store.state.isSliderCondensed,
        }}
      >
        <div
          class={`swiper-container swiper-container-${this.uniqueId}`}
          ref={(el) => {
            this.container = el as HTMLDivElement;
          }}
        >
          <div
            class="swiper-wrapper"
            ref={(el) => {
              this.wrapper = el as HTMLDivElement;
            }}
          >
            {store.state.resultsVisible?.map((result, index) => (
              <ui-bank-search-mobile-slide key={index} class="swiper-slide">
                <ui-bank-search-mobile-item
                  bank={result}
                ></ui-bank-search-mobile-item>
              </ui-bank-search-mobile-slide>
            ))}
          </div>
        </div>
      </Host>
    );
  }
}
